import { Theme } from './Theme';

export function isValidTheme(theme: unknown): theme is Theme {
  return Object.values(Theme).includes(theme as Theme);
}
